// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"973aadb9","455":"6a641d14"}[chunkId] + ".chunk.js";
};